/**
 * Custom STRL scripts
 */
(function($) {
// Disable eslint to avoid "$ is not defined" error
/* eslint-disable */
	$('.Recipes-filter-toggle').on('click', function() {
		$('#SidebarRecipes').toggleClass('sidebar-open');
	});
/* eslint-enable */
})(jQuery)
